import { Flex } from '@buffer-mono/popcorn'

import { MetricDifference } from '../MetricDifference'
import { MetricNumber } from '../MetricNumber'

import styles from './MetricValue.module.css'

import type { PostMetricUnit } from '../../graphqlEnums'
import type { JSX } from 'react'

interface Metric {
  value: number
  unit: PostMetricUnit
  difference?: number | null
}

interface MetricValueProps {
  metric?: Metric | null
  loading?: boolean
  size?: 'small' | 'medium'
}

function renderValue(value: number, unit: PostMetricUnit): JSX.Element {
  if (unit === 'percentage') {
    return <>{value}%</>
  }
  return <MetricNumber value={value} />
}

export function MetricValue({
  metric,
  loading = false,
  size = 'medium',
}: MetricValueProps): JSX.Element {
  return (
    <Flex
      align="center"
      gap="xs"
      className={loading ? styles.loading : undefined}
    >
      {metric ? (
        <>
          {renderValue(metric.value, metric.unit)}
          {metric.difference != null && (
            <MetricDifference difference={metric.difference} size={size} />
          )}
        </>
      ) : (
        // En dash, the Insights glyph for "no data" (see ChartTooltipView) —
        // not an ASCII hyphen.
        '–'
      )}
    </Flex>
  )
}
